export default __webpack_public_path__ + "static/farm_video-6f740ad38f7cc8354e3402ec1a55384c.png";